import { consumerTheme, fontSizes, fontWeights, notificationBar, opacities, spacing, statusColors, colors as themeColors } from 'syf-component-library/defaultTheme';
const colors = Object.assign(Object.assign({}, themeColors), { denimBlue: '#34657f', greyNinetyEight: '#fafafa' });
const theme = Object.assign(Object.assign({}, consumerTheme), { colors: Object.assign(Object.assign({}, colors), { greyNinetyEight: '#fafafa' }), fontSizes: Object.assign(Object.assign({}, fontSizes), { regular: 14, xsmall: 10 }), fontWeights, lineHeights: {
        small: '20px',
        root: '24px',
        medium: '28px',
        large: '30px'
    }, notificationBar,
    opacities, spacing: Object.assign(Object.assign({}, spacing), { huge: 48 }), statusColors });
export default theme;
//# sourceMappingURL=theme.js.map